import axios from "axios";
import {
  Button,
  IconButton,
  Typography
} from "@mui/material";
import styles from "./style.module.css";
import SearchIcon from "@mui/icons-material/Search";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import {
  GridColDef,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import CircularModal from '../../custom/circularModalLoader/circularModalLoader';
import ReportsTable from '../../custom/reportsTable';
// import { errorToast, pvcStockInDetails } from "../../../../utils/constants";
import {
  CalendarIcon,
  LocalizationProvider,
  MobileDatePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment, { MomentInput } from "moment";
import { pvcStockInDetails } from "../../../utils/constant";
import Title from "../../custom/Title";
import { getStockInReport } from "../../../services/Reports";
import useService from "../../../hooks/useService";
import { AuthContext } from "../../../contexts/AuthContext";



const DataGridContainer = styled.div`
  height: calc(100%);
  overflow-x: auto;
`;
export const StockInReport = () => {
  let sessionId: any = localStorage.getItem("sessionId");
  const [loading, setLoading] = useState(false);
  const [pvcStockInOrders, setPvcStockInOrders] = useState<any>([]);
  const [fromDate, setFromDate] = useState<any>(new Date().toString());
  const [toDate, setToDate] = useState<any>(new Date().toString());
  const [destinationOptions, setDestinationOptions] = useState<any>([]);
  const { execute } = useService();
  const { user: { centerId }, pvcAddresses } = useContext(AuthContext)



  const getDestination = async () => {
    try {
      setLoading(true);
      const params = { sessionid: sessionId };
      const response = await axios.post(
        "/api/commerce/inventoryManagement/fetchBusinessUnits",
        params
      );
      setLoading(false);
      setDestinationOptions(response?.data);
    } catch (error) {
      setLoading(false);
      console.error(error);
    //   errorToast("Unable to get destinations!");
    }
  };

  const checkDateDifference = (fromDate: Date, toDate: Date) => {
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    const differenceInTime = toDateObj.getTime() - fromDateObj.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    if (differenceInDays > 30) return true;
    else return false;
  };

  const getPvcStockInData = async () => {
    try {
      let dateRange = checkDateDifference(fromDate, toDate);
      if (dateRange) return alert("Date range should be less than 30 days!");

      let centerIds = centerId

      setLoading(true);
      const params = {
        centerIds,
        fromDate,
        toDate,
      };

    //   const response = await axios.post(
    //     "/api/pvcReports/getStockInReport",
    //     params
    //   );
      const { data } = await execute(() => getStockInReport({params}))

      setLoading(false);
      setPvcStockInOrders(data?.data || []);
    } catch (error) {
      setLoading(false);
      console.error(error);
      alert("Unable to get pvc stock-in orders!");
    }
  };

  const getPvcStockDataColumns = () => {
    let minWidth = 100;

    return pvcStockInDetails.map((inboundField: any) => {
      const row: GridColDef = {
        field: inboundField.id,
        headerName: inboundField.label,
        minWidth,
        align: "left",
      };

      switch (inboundField.id) {
        case "srNo":
          row.minWidth = 100;
          row.valueGetter = (params) => {
            return params.row.srNo
          };
          break;
        case "exciseNo":
          row.minWidth = 100;
          row.valueGetter = (params) => {
            return params.row.exciseNo ? params.row.exciseNo : 0;
          };
          break;
        case "stockTransferNo":
          row.minWidth = 200;
          row.valueGetter = (params) => {
            return params.row.stockTransferNo
              ? params.row.stockTransferNo
              : "NA";
          };
          break;
        case "stockTransferDate":
          row.minWidth = 180;
          row.valueGetter = (params) => {
            return params.row.stockTransferDate
              ? params.row.stockTransferDate
              : "NA";
          };
          break;
        case "destinationLcoation":
          row.minWidth = 350;
          row.valueGetter = (params) => {
            return params.row.destinationLcoation
              ? params.row.destinationLcoation
              : "NA";
          };
          break;
        case "metal":
          row.minWidth = 120;
          row.valueGetter = (params) => {
            return params.row.metal ? params.row.metal : "NA";
          };
          break;
        case "purity":
          row.minWidth = 100;
          row.valueGetter = (params) => {
            return params.row.purity ? params.row.purity : "NA";
          };
          break;
        case "denomination":
          row.minWidth = 150;
          row.valueGetter = (params) => {
            return params.row.denomination ? params.row.denomination : "NA";
          };
          break;
        case "productDesign":
          row.minWidth = 350;
          row.valueGetter = (params) => {
            return params.row.productDesign ? params.row.productDesign : "NA";
          };
          break;
        case "totalNetWeight":
          row.minWidth = 150;
          row.valueGetter = (params) => {
            return params.row.totalNetWeight ? params.row.totalNetWeight :0 ;
          };
          break;
        case "transferredQty":
          row.minWidth = 150;
          row.valueGetter = (params) => {
            return params.row.transferredQty ? params.row.transferredQty : 0;
          };
          break;
        case "balanceQuantity":
          row.minWidth = 150;
          row.valueGetter = (params) => {
            return params.row.balanceQuantity
              ? params.row.balanceQuantity
              : 0;
          };
          break;
        case "agingDays":
          row.minWidth = 100;
          row.valueGetter = (params) => {
            return params.row.agingDays ? params.row.agingDays : 0;
          };
          break;
        case "serialNumbers":
          row.minWidth = 220;
          row.valueGetter = (params) => {
            return params.row.serialNumbers ? params.row.serialNumbers : "NA";
          };
          break;
        default:
          row.minWidth = 100;
          break;
      }
      return row;
    });
  };

  const filterModal = () => {
    return (
      <Box className={styles.filterModal}>
        <Box className={styles.boxModalOne}>
        </Box>
        <Box className={styles.filterModalRow}>
          <Box className={styles.boxModalTwo}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  field: {
                    InputProps: {
                      endAdornment: (
                        <IconButton>
                          <CalendarIcon />
                        </IconButton>
                      ),
                    },
                  },
                }}
                label="Start Date"
                onChange={(value) => setFromDate(value?.toString()!)}
                value={moment(
                  fromDate || (new Date().toString() as MomentInput)
                )}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <MobileDatePicker
                slotProps={{
                  textField: { fullWidth: true, size: "small" },
                  field: {
                    InputProps: {
                      endAdornment: (
                        <IconButton>
                          <CalendarIcon />
                        </IconButton>
                      ),
                    },
                  },
                }}
                label="End Date"
                onChange={(value) => setToDate(value?.toString()!)}
                value={moment(toDate || (new Date().toString() as MomentInput))}
              />
            </LocalizationProvider>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={getPvcStockInData}
              endIcon={<SearchIcon />}
              disabled={!fromDate || !toDate}
            >
              Apply Filter
            </Button>
          </Box>
        </Box>
        <Typography variant="caption" display="block" marginTop="5px">
          {'Note: Date filter will be applicable on Stock transfer created date.'}
        </Typography>
      </Box>
    );
  };

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarExport csvOptions={{ fileName: "StockInReport" }} />
      </GridToolbarContainer>
    );
  };

  const renderTable = () => {
    return (
      <>
        <div>
          {loading && <CircularModal thickness={4} />}
          <Box sx={{ width: "100%", height: '500px', overflow: 'auto' }}>
            <DataGridContainer>
              <ReportsTable
                className="payrollGrid"
                rows={pvcStockInOrders || []}
                columns={getPvcStockDataColumns()}
                getRowId={(row) => row.srNo}
                disableRowSelectionOnClick={true}
                rowHeight={50}
                slots={{ toolbar: CustomToolbar }}
                hideFooter={true}
                fixedHeight={true}
              />
            </DataGridContainer>
          </Box>
        </div>
      </>
    );
  };

  useEffect(() => {
    getDestination()
  }, [])

  return (
    <Box className={styles.container}>
    <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Stock In Report</Title>
      {filterModal()}
      {renderTable()}
    </Box>
  );
};
